import React from 'react'
import { Formik } from 'formik'
import { DropEvent } from 'react-dropzone'
import { Dialog, DialogTitle } from '@material-ui/core'
import { IFile } from '../../types/file'
import { IArchiveItem } from '../../selectors/pack'
import {
  calculateInitialValuesForUploadModalForm,
  filterEditionToUpdateByOption,
} from '../../services/file'
import { UploadModalForm } from './UploadModalForm'
import { createFileUploadValidationSchema } from './validation'

export interface IModal {
  open: boolean
  title: string
  id?: string
  actionLabel?: string
  file: IFile
  relatedEditions: IArchiveItem[]
  fileTemporaryURL: string | null
  showThumbnail: boolean
  action: (fileName: string, editionsToUpdate?: string[]) => void
  handleClose: () => void
  onDrop?: (e: DropEvent) => void
}

export const UploadModal = ({
  open,
  title,
  id,
  file,
  relatedEditions,
  fileTemporaryURL,
  showThumbnail,
  action,
  handleClose,
  onDrop,
}: IModal) => (
  <Dialog
    id={id}
    maxWidth="sm"
    fullWidth
    open={open}
    onClose={handleClose}
    aria-labelledby="alert-dialog-title"
    aria-describedby="alert-dialog-description"
    disableBackdropClick
    onDrop={onDrop}
  >
    <DialogTitle id="alert-dialog-title">{title}</DialogTitle>
    <Formik
      initialValues={calculateInitialValuesForUploadModalForm(
        file,
        relatedEditions
      )}
      onSubmit={(values) => {
        const editionsToUpdate = values.archiveFilesToUpdate
          .filter(filterEditionToUpdateByOption(values.archiveUpdateOptions))
          .map((edition) => edition.id)
        action(values.fileName.trim(), editionsToUpdate)
      }}
      render={(formikProps) => (
        <UploadModalForm
          formikProps={formikProps}
          file={file}
          showThumbnail={showThumbnail}
          fileTemporaryURL={fileTemporaryURL}
          handleClose={handleClose}
        />
      )}
      validationSchema={createFileUploadValidationSchema(file.extension.length)}
    />
  </Dialog>
)
